import { getLastSortedColumnValue, getLastBiddingColumnId } from '../utils/pagination';
import {
    BIDDING_FETCH_ENABLE_LOADING,
    BIDDING_FETCH_DISABLE_LOADING,
    BIDDING_FETCH_LOADED,
    BIDDING_FETCH_ERROR,
    BIDDING_RESET_FILTERS,
    BIDDING_SET_PAGINATION,
    BIDDING_RESET_PAGINATION,
    BIDDING_UPDATE_FILTERS,
} from '../actions/constants';
const defaultState = {
  isLoading: true,
  errorMessage: null,
  biddingList: null,
  selectedFilters: {
    statuses: [],
    periods: [],
    rfqTypes: [],
    searchQuery: '',
  },
  pagination: {
    currentPageNumber:1,
    nextOrPrev:'first',
    isNextPresent: true,
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case BIDDING_FETCH_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case BIDDING_FETCH_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case BIDDING_FETCH_LOADED: {
      return {
        ...state,
        biddingList: action.data.data,
        errorMessage: null,
        pagination: {
          ...state.pagination,
          currentPageNumber: action.data.currentPageNumber,
          isNextPresent: action.data.isNextPresent,
          lastSortedColumnValueNext: action.data.lastSortedColumnValueNext,
          lastItemIdNext: action.data.lastItemIdNext,
          lastSortedColumnValuePrev: action.data.lastSortedColumnValuePrev,
          lastItemIdPrev: action.data.lastItemIdPrev,
          lastSortedColumnValue: getLastSortedColumnValue(action.data),
          lastRowId: getLastBiddingColumnId(action.data),
        },
      };
    }
    case BIDDING_FETCH_ERROR: {
      return {
        ...state,
        biddingList: null,
        errorMessage: action.errorMessage,
      };
    }
    case BIDDING_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
        pagination: defaultState.pagination,
      };
    }
    case BIDDING_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }
    case BIDDING_UPDATE_FILTERS: {
      return {
        ...state,
        selectedFilters: Object.assign({}, state.selectedFilters, action.data),
      };
    }
    case BIDDING_SET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    default: {
      return state;
    }
  }
}
